// tslint:disable
export var PharmacyJobType;
(function (PharmacyJobType) {
    // Triage to Pharmacy Inbound Feed
    PharmacyJobType[PharmacyJobType["T2PInboundFeed"] = 1] = "T2PInboundFeed";
})(PharmacyJobType || (PharmacyJobType = {}));
PharmacyJobType['T2PINBOUNDFEED'] = 1;
//# sourceMappingURL=PharmacyJobType.js.map